import { useTranslation } from "react-i18next";

const StartCourseExamCard = ({
  duration,
  numberOfQuestion,
  handleStartingExam,
  examTitle,
  currentLessonLog,
}) => {
  const { t } = useTranslation("learningPaths");

  return (
    <div className="card-style card-course-exam">
      <h4 className="font_24 font-extrabold">{examTitle}</h4>

      {currentLessonLog?.progress == 100 ? (
        <p className="mb-0">{t("examAlreadyCompleted")}</p>
      ) : (
        <>
          <ul className="card-course-exam__meta d-flex flex-wrap mt-4 mb-0 gap-3 gap-md-4">
            {duration && (
              <li className="d-flex align-items-center">
                <i className="fas fa-clock font-color-red font_20"></i>
                <div className="ms-2">
                  <small className="font_12 font-color-grey">
                    {t("examDurationLabel")}
                  </small>
                  <p className="font_18 font-extrabold mb-0">
                    {duration} {t("minutesUnit")}
                  </p>
                </div>
              </li>
            )}
            <li className="d-flex align-items-center">
              <i className="fas fa-question-circle font-color-red font_20"></i>
              <div className="ms-2">
                <small className="font_12 font-color-grey">
                  {t("examQuestionsLabel")}
                </small>
                <p className="font_18 font-extrabold mb-0">
                  {t("examQuestionsCount", { count: numberOfQuestion })}
                </p>
              </div>
            </li>
          </ul>

          <div className="card-course-exam__list">
            <h6 className="font_16 font-extrabold font-color-grey card-course-exam__title">
              {t("pathExamRulesTitle")}
            </h6>
            <ul>
              <li className="font_14 font-color-grey card-course-exam__list__item">
                {t("pathExamRuleCompleteInTime")}
              </li>
              <li className="font_14 font-color-grey card-course-exam__list__item">
                {t("pathExamRuleAutoClose")}
              </li>
              <li className="font_14 font-color-grey card-course-exam__list__item">
                {t("pathExamRuleOneAttempt")}
              </li>
            </ul>
          </div>

          <button
            className="btn btn-main-color card-course-exam__action"
            onClick={handleStartingExam}
          >
            {t("startPathExam")}
            <span className="fas fa-arrow-right fa-fw ms-2"></span>
          </button>
        </>
      )}
    </div>
  );
};

export default StartCourseExamCard;
